/*@flow*/
import type { Node } from 'react';
import React, { useContext } from 'react';
import { StackContext } from './contexts';
import compose from 'lib/compose';
import Panel from './Panel';
import type { DotTypeT, DotStyleT } from 'comps/Dot';

const is = (name) => (v) => v.type === name;
const has = (key) => (v) => v[key];
const filter = (pred) => (v) => v.filter(pred);
const getOwn = compose(
  filter(has('color')),
  filter(is('custom'))
);

export type CustomT = {
  type: string,
  title: string,
  color: string,
  dotStyle: DotStyleT,
  dotType: DotTypeT,
  uuid: string,
  category_type: string,
};

// Custom Panel (singular)
// -------------------
//
// The most basic type of legend panel. All others build upon this panel type.
//
// {
//   type: 'custom',
//   title: 'Foo',
//   color: '#C0FFEE',
//   dotStyle: 'fill',
//   dotType: 'circle'
// }
const Component = ({
  setInternalUpdate,
  internalUpdate,
}: {
  internalUpdate: any,
  setInternalUpdate: Function,
}): null | Node | Array<any> => {
  const legends = useContext(StackContext);
  const ownLegends = getOwn(legends);
  if (ownLegends.isEmpty()) return null;
  let ol = ownLegends.toJS();
  if (!Array.isArray(ol)) return ([]: any[]);
  ol = ((ol: any): CustomT[]);
  const items = ol.map((v) => ({ ...v, label: v.title }));
  return (
    <Panel
      type="custom"
      category_type=""
      uuid=""
      title="Layers"
      items={items}
      historyFilters={{}}
      setInternalUpdate={setInternalUpdate}
      internalUpdate={internalUpdate}
    />
  );
};
export default Component;
